import { trackCatalogEvent } from '@/core/services/trackDynatraceCatalog';
import { useEffect, useRef } from 'react';

/**
 * Fire a catalogue `view` once when `enabled` becomes true (e.g. after detail data loads).
 */
export function useCatalogDynatraceView(
    screen: string,
    actionName: string,
    enabled: boolean,
    properties?: Record<string, string | number | boolean | undefined>,
): void {
    const firedRef = useRef(false);
    const propertiesRef = useRef(properties);
    propertiesRef.current = properties;

    useEffect(() => {
        if (!enabled || firedRef.current) {
            return;
        }
        firedRef.current = true;
        trackCatalogEvent({
            screen,
            actionName,
            eventType: 'view',
            properties: propertiesRef.current,
        });
    }, [enabled, screen, actionName]);
}
